/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React          from 'react';
import styled         from 'styled-components';
import PropTypes      from 'prop-types';
import { Colours }    from '../../../styles/variables';
import { Media }      from '../../../styles/utilities';
import { IconBurger } from '../IconBurger';
import { IconClose }  from '../IconClose';


/*********************************************************************************
 2. Component
 *********************************************************************************/

// TODO: too much happening in this component - should abstract to styled burger and move burger to molecule

const StyledBurger = styled.div`
  margin-left: auto;
  z-index: 2;
  color: ${props => (props.isOpen) ? Colours.White : 'inherit' };
  ${Media.Tablet`
    display: none;
  `}
`;

export const Burger = ({ onBurgerClick, isNavigationOpen }) => (
    <StyledBurger onClick={onBurgerClick} isOpen={isNavigationOpen}>
        {!isNavigationOpen ? (
            <IconBurger/>
        ) : (
            <IconClose/>
        )}
        
    </StyledBurger>
);

Burger.propTypes = {
    isNavigationOpen: PropTypes.bool.isRequired,
    onBurgerClick: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/atoms/Burger/index.js